import { render } from "./AdvertImagePicker.vue?vue&type=template&id=9dbb304a"
import script from "./AdvertImagePicker.vue?vue&type=script&lang=js"
export * from "./AdvertImagePicker.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__